// Mock backend for the breakfast ad-campaign capture form.
// Replace with a real `api.post(...)` call (see src/utils/api.ts) once a
// live endpoint exists - the shape of the response is deliberately kept
// compatible with that helper.

export interface BreakfastCaptureData {
  fullName: string;
  email: string;
  phone?: string;
}

export interface MockCaptureResponse {
  success: boolean;
  discountCode?: string;
  error?: string;
}

const STORAGE_KEY = 'creamery_breakfast_leads';
const DISCOUNT_CODE = 'BREKKIE10';

export const mockCaptureApi = {
  async submit(data: BreakfastCaptureData): Promise<MockCaptureResponse> {
    // Simulate network latency so the UI behaves like a real submission
    await new Promise((resolve) => setTimeout(resolve, 800));

    try {
      const entry = {
        ...data,
        discountCode: DISCOUNT_CODE,
        submittedAt: new Date().toISOString(),
      };

      const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      existing.push(entry);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));

      console.info('[mock] Breakfast capture stored:', entry);

      return { success: true, discountCode: DISCOUNT_CODE };
    } catch (error) {
      console.error('[mock] Failed to store capture:', error);
      return {
        success: false,
        error: 'Unable to save your details right now. Please try again.',
      };
    }
  },
};
